import { Box, IconButton } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { FixedSizeList as List } from 'react-window';
import styled from 'styled-components';
import { abyssColors } from '@/theme/colors';

export const ScrollContainer = muiStyled(Box)({
  flex: 1,
  overflow: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  height: '100%',
});

export const StyledList = styled(List)`
  transition: all 0.2s ease-in-out;
  ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const FloatingButton = muiStyled(IconButton)(() => ({
  position: 'absolute',
  bottom: '12rem',
  right: '2rem',
  zIndex: 10,
  backgroundColor: abyssColors.primary[500],
  color: 'white',
  '&:hover': {
    backgroundColor: abyssColors.primary[600],
  },
}));
